<template>
  <div class="">
    <div class="">
      <LeftCard />
    </div>
    <div class="">
      <!-- <Testcases /> -->
    </div>
  </div>
</template>
<script>
import LeftCard from "./LeftCard";
import Testcases from "../../components/Testcases";
export default {
  components: {
    LeftCard,
    Testcases,
  },
};
</script>
